// removed by extract-text-webpack-plugin
module.exports = {"IconWrapper":"SideMenuItem-module__IconWrapper__8zg5O","Icon":"SideMenuItem-module__Icon__4kzRq","IconSvg":"SideMenuItem-module__IconSvg__cOUbd","MenuWrapper":"SideMenuItem-module__MenuWrapper__1486c","NavLink":"SideMenuItem-module__NavLink__3EaW5","Txt":"SideMenuItem-module__Txt__1SWLy","Badge":"SideMenuItem-module__Badge__1IGu3","BadgeNumber":"SideMenuItem-module__BadgeNumber__10L2b","Active":"SideMenuItem-module__Active__3EalK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/LeftSidebar/SideMenuItem/SideMenuItem.module.css
// module id = 1803
// module chunks = 31